import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UsersFilterEntity } from '../../domain/entities/UsersFilterEntity'

export class UsersFilterModel extends UsersFilterEntity {
  roleId?: number
  regionId?: number
  baseRoleId?: number
  birthDateFrom?: string
  birthDateTo?: string
  createdAtFrom?: string
  createdAtTo?: string

  constructor(dataDto: UsersFilterEntity) {
    super()
    mapEntityProperties<UsersFilterModel>(this, dataDto, {
      exclude: ['role', 'region' , 'baseRole' , 'date' , 'birthDate'],
      map: {
        regionId: dataDto.region?.id,
        roleId: dataDto.role?.id,
        baseRoleId: dataDto.baseRole?.id,
        date: dataDto.date,
        birthDateFrom: dataDto.birthDate ? dataDto.birthDate[0] : undefined,
        birthDateTo: dataDto.birthDate ? dataDto.birthDate[1] : undefined,
        createdAtFrom: dataDto.date ? dataDto.date[0] : undefined,
        createdAtTo: dataDto.date ? dataDto.date[1] : undefined,
         
      }
    })
  }
}
